// extracted by mini-css-extract-plugin
export default {"switch":"pGyjMjBpXtE9ZBSDGUap","checked":"nPw0QVFehFLFRkdLioAU"};